import React from "react";

import { isMobilePhone } from "@/utils/getters";

import { Divider, Image, ImageWrapper, Section } from "./styles";

export type ImageQuestionProps = {
  imageUrl: string;
};

const ImageQuestion: React.FC<ImageQuestionProps> = (
  props: ImageQuestionProps
): React.JSX.Element => {
  // load always as small as possible images from images-service "dali" because of caching and speed
  const maxImageWidth = isMobilePhone() ? 480 : 560;
  const imageUrl = `${props.imageUrl}?width=${maxImageWidth}`;

  return (
    <Section>
      <ImageWrapper>
        <Image src={imageUrl} />
      </ImageWrapper>
      <Divider />
    </Section>
  );
};

export default ImageQuestion;
